import { api } from 'services/api'

export async function updateClientLotteries(payload) {
  const { data } = await api.put('/clients/lotteries', payload)
  return data
}
